import { useQuery } from '@tanstack/react-query';
import { DateTime } from 'luxon';
import { analyticsControllerGetTenantHome } from '@/generated/korza-api-client';
import { useTenant } from '@/hooks/use-tenant';

const ONE_HOUR_MS = 60 * 60 * 1000;

/** Store currency from `GET tenants/:slug/analytics/home` (today's window). */
export function useStoreCurrency(): {
  currency: string | undefined;
  isError: boolean;
} {
  const tenant = useTenant();

  const query = useQuery({
    queryKey: ['store-currency', tenant.slug],
    queryFn: async () => {
      const now = DateTime.now();
      const response = await analyticsControllerGetTenantHome({
        path: { tenantSlug: tenant.slug },
        query: {
          fromDate: now.startOf('day').toISO(),
          toDate: now.toISO(),
        },
        throwOnError: true,
      });
      return response.data.currency;
    },
    staleTime: ONE_HOUR_MS,
  });

  return { currency: query.data, isError: query.isError };
}

/** What consumers format with: `undefined` (skeleton) while loading, BRL only on error. */
export function currencyForDisplay({
  currency,
  isError,
}: {
  currency: string | undefined;
  isError: boolean;
}): string | undefined {
  return currency ?? (isError ? 'BRL' : undefined);
}
